import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import Sidebar from "../common/Sidebar";
import HeaderBar from "../common/HeaderBar";
import ProfileDrawer from "../common/ProfileDrawer";
import { useDispatch } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";
import SidebarDrawer from "../common/SidebarDrawer";
import { validate } from "../store/authSlice";

const { Sider, Content } = Layout;

export default function MainLayout({ user }) {
  const [profileOpen, setProfileOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const openProfile = () => setProfileOpen(true);
  const closeProfile = () => setProfileOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    dispatch({ type: "LOGOUT" });

    setProfileOpen(false);
    navigate("/login");
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


useEffect(() => {
  const init = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setLoading(false);
      return;
    }

    // 🚫 prevent duplicate API calls
    if (user) {
      setLoading(false);
      return;
    }

    try {
      await dispatch(validate());
    } catch (err) {
      localStorage.removeItem("token");
      dispatch({ type: "LOGOUT" });
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  init();
}, [user]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* SIDEBAR */}
      {!isMobile ? (
        <Sider
          width={220}
          style={{
            height: "100%",
            position: "sticky",
            top: 0,
          }}
        >
          <Sidebar openProfile={openProfile} loading={loading} />
        </Sider>
      ) : (
        <SidebarDrawer openProfile={openProfile} loading={loading} />
      )}

      {/* MAIN AREA */}
      <Layout style={{ display: "flex", flexDirection: "column" }}>
        <HeaderBar openProfile={openProfile} user={user} isMobile={isMobile} />

        <Content
          style={{
            flex: 1,
            minHeight: 0,
            padding: 24,
            background: "#f5f6fa",
            overflow: "auto",
          }}
        >
          <Outlet />
        </Content>
      </Layout>

      {/* PROFILE DRAWER */}
      <ProfileDrawer
        open={profileOpen}
        onClose={closeProfile}
        user={user}
        onLogout={handleLogout}
      />
    </Layout>
  );
}
